import localVarRequest from 'request';

export * from './folderFolderIdViewColumns';
export * from './folderFolderIdViewDivide';
export * from './folderFolderIdViewFilters';
export * from './folderFolderIdViewGrouping';
export * from './folderFolderIdViewSettings';
export * from './folderFolderIdViewTeamSidebar';
export * from './groupGroupIdMembers';
export * from './inlineObject';
export * from './inlineObject1';
export * from './inlineObject10';
export * from './inlineObject11';
export * from './inlineObject12';
export * from './inlineObject13';
export * from './inlineObject14';
export * from './inlineObject15';
export * from './inlineObject16';
export * from './inlineObject17';
export * from './inlineObject18';
export * from './inlineObject19';
export * from './inlineObject2';
export * from './inlineObject20';
export * from './inlineObject21';
export * from './inlineObject22';
export * from './inlineObject23';
export * from './inlineObject24';
export * from './inlineObject25';
export * from './inlineObject26';
export * from './inlineObject27';
export * from './inlineObject28';
export * from './inlineObject29';
export * from './inlineObject3';
export * from './inlineObject30';
export * from './inlineObject31';
export * from './inlineObject32';
export * from './inlineObject33';
export * from './inlineObject34';
export * from './inlineObject35';
export * from './inlineObject36';
export * from './inlineObject37';
export * from './inlineObject38';
export * from './inlineObject39';
export * from './inlineObject4';
export * from './inlineObject40';
export * from './inlineObject41';
export * from './inlineObject42';
export * from './inlineObject43';
export * from './inlineObject44';
export * from './inlineObject5';
export * from './inlineObject6';
export * from './inlineObject7';
export * from './inlineObject8';
export * from './inlineObject9';
export * from './listListIdTaskCustomFields';
export * from './spaceSpaceIdFeatures';
export * from './spaceSpaceIdFeaturesDueDates';
export * from './spaceSpaceIdFeaturesTags';
export * from './spaceSpaceIdTagTag';
export * from './teamTeamIdTimeEntriesTagsTags';
export * from './viewViewIdParent';

import * as fs from 'fs';

export interface RequestDetailedFile {
    value: Buffer;
    options?: {
        filename?: string;
        contentType?: string;
    }
}

export type RequestFile = string | Buffer | fs.ReadStream | RequestDetailedFile;


import { FolderFolderIdViewColumns } from './folderFolderIdViewColumns';
import { FolderFolderIdViewDivide } from './folderFolderIdViewDivide';
import { FolderFolderIdViewFilters } from './folderFolderIdViewFilters';
import { FolderFolderIdViewGrouping } from './folderFolderIdViewGrouping';
import { FolderFolderIdViewSettings } from './folderFolderIdViewSettings';
import { FolderFolderIdViewTeamSidebar } from './folderFolderIdViewTeamSidebar';
import { GroupGroupIdMembers } from './groupGroupIdMembers';
import { InlineObject } from './inlineObject';
import { InlineObject1 } from './inlineObject1';
import { InlineObject10 } from './inlineObject10';
import { InlineObject11 } from './inlineObject11';
import { InlineObject12 } from './inlineObject12';
import { InlineObject13 } from './inlineObject13';
import { InlineObject14 } from './inlineObject14';
import { InlineObject15 } from './inlineObject15';
import { InlineObject16 } from './inlineObject16';
import { InlineObject17 } from './inlineObject17';
import { InlineObject18 } from './inlineObject18';
import { InlineObject19 } from './inlineObject19';
import { InlineObject2 } from './inlineObject2';
import { InlineObject20 } from './inlineObject20';
import { InlineObject21 } from './inlineObject21';
import { InlineObject22 } from './inlineObject22';
import { InlineObject23 } from './inlineObject23';
import { InlineObject24 } from './inlineObject24';
import { InlineObject25 } from './inlineObject25';
import { InlineObject26 } from './inlineObject26';
import { InlineObject27 } from './inlineObject27';
import { InlineObject28 } from './inlineObject28';
import { InlineObject29 } from './inlineObject29';
import { InlineObject3 } from './inlineObject3';
import { InlineObject30 } from './inlineObject30';
import { InlineObject31 } from './inlineObject31';
import { InlineObject32 } from './inlineObject32';
import { InlineObject33 } from './inlineObject33';
import { InlineObject34 } from './inlineObject34';
import { InlineObject35 } from './inlineObject35';
import { InlineObject36 } from './inlineObject36';
import { InlineObject37 } from './inlineObject37';
import { InlineObject38 } from './inlineObject38';
import { InlineObject39 } from './inlineObject39';
import { InlineObject4 } from './inlineObject4';
import { InlineObject40 } from './inlineObject40';
import { InlineObject41 } from './inlineObject41';
import { InlineObject42 } from './inlineObject42';
import { InlineObject43 } from './inlineObject43';
import { InlineObject44 } from './inlineObject44';
import { InlineObject5 } from './inlineObject5';
import { InlineObject6 } from './inlineObject6';
import { InlineObject7 } from './inlineObject7';
import { InlineObject8 } from './inlineObject8';
import { InlineObject9 } from './inlineObject9';
import { ListListIdTaskCustomFields } from './listListIdTaskCustomFields';
import { SpaceSpaceIdFeatures } from './spaceSpaceIdFeatures';
import { SpaceSpaceIdFeaturesDueDates } from './spaceSpaceIdFeaturesDueDates';
import { SpaceSpaceIdFeaturesTags } from './spaceSpaceIdFeaturesTags';
import { SpaceSpaceIdTagTag } from './spaceSpaceIdTagTag';
import { TeamTeamIdTimeEntriesTagsTags } from './teamTeamIdTimeEntriesTagsTags';
import { ViewViewIdParent } from './viewViewIdParent';

/* tslint:disable:no-unused-variable */
let primitives = [
                    "string",
                    "boolean",
                    "double",
                    "integer",
                    "long",
                    "float",
                    "number",
                    "any"
                 ];

let enumsMap: {[index: string]: any} = {
}

let typeMap: {[index: string]: any} = {
    "FolderFolderIdViewColumns": FolderFolderIdViewColumns,
    "FolderFolderIdViewDivide": FolderFolderIdViewDivide,
    "FolderFolderIdViewFilters": FolderFolderIdViewFilters,
    "FolderFolderIdViewGrouping": FolderFolderIdViewGrouping,
    "FolderFolderIdViewSettings": FolderFolderIdViewSettings,
    "FolderFolderIdViewTeamSidebar": FolderFolderIdViewTeamSidebar,
    "GroupGroupIdMembers": GroupGroupIdMembers,
    "InlineObject": InlineObject,
    "InlineObject1": InlineObject1,
    "InlineObject10": InlineObject10,
    "InlineObject11": InlineObject11,
    "InlineObject12": InlineObject12,
    "InlineObject13": InlineObject13,
    "InlineObject14": InlineObject14,
    "InlineObject15": InlineObject15,
    "InlineObject16": InlineObject16,
    "InlineObject17": InlineObject17,
    "InlineObject18": InlineObject18,
    "InlineObject19": InlineObject19,
    "InlineObject2": InlineObject2,
    "InlineObject20": InlineObject20,
    "InlineObject21": InlineObject21,
    "InlineObject22": InlineObject22,
    "InlineObject23": InlineObject23,
    "InlineObject24": InlineObject24,
    "InlineObject25": InlineObject25,
    "InlineObject26": InlineObject26,
    "InlineObject27": InlineObject27,
    "InlineObject28": InlineObject28,
    "InlineObject29": InlineObject29,
    "InlineObject3": InlineObject3,
    "InlineObject30": InlineObject30,
    "InlineObject31": InlineObject31,
    "InlineObject32": InlineObject32,
    "InlineObject33": InlineObject33,
    "InlineObject34": InlineObject34,
    "InlineObject35": InlineObject35,
    "InlineObject36": InlineObject36,
    "InlineObject37": InlineObject37,
    "InlineObject38": InlineObject38,
    "InlineObject39": InlineObject39,
    "InlineObject4": InlineObject4,
    "InlineObject40": InlineObject40,
    "InlineObject41": InlineObject41,
    "InlineObject42": InlineObject42,
    "InlineObject43": InlineObject43,
    "InlineObject44": InlineObject44,
    "InlineObject5": InlineObject5,
    "InlineObject6": InlineObject6,
    "InlineObject7": InlineObject7,
    "InlineObject8": InlineObject8,
    "InlineObject9": InlineObject9,
    "ListListIdTaskCustomFields": ListListIdTaskCustomFields,
    "SpaceSpaceIdFeatures": SpaceSpaceIdFeatures,
    "SpaceSpaceIdFeaturesDueDates": SpaceSpaceIdFeaturesDueDates,
    "SpaceSpaceIdFeaturesTags": SpaceSpaceIdFeaturesTags,
    "SpaceSpaceIdTagTag": SpaceSpaceIdTagTag,
    "TeamTeamIdTimeEntriesTagsTags": TeamTeamIdTimeEntriesTagsTags,
    "ViewViewIdParent": ViewViewIdParent,
}

export class ObjectSerializer {
    public static findCorrectType(data: any, expectedType: string) {
        if (data == undefined) {
            return expectedType;
        } else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        } else if (expectedType === "Date") {
            return expectedType;
        } else {
            if (enumsMap[expectedType]) {
                return expectedType;
            }

            if (!typeMap[expectedType]) {
                return expectedType; // w/e we don't know the type
            }

            // Check the discriminator
            let discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType; // the type does not have a discriminator. use it.
            } else {
                if (data[discriminatorProperty]) {
                    var discriminatorType = data[discriminatorProperty];
                    if(typeMap[discriminatorType]){
                        return discriminatorType; // use the type given in the discriminator
                    } else {
                        return expectedType; // discriminator did not map to a type
                    }
                } else {
                    return expectedType; // discriminator was not present (or an empty string)
                }
            }
        }
    }

    public static serialize(data: any, type: string) {
        if (data == undefined) {
            return data;
        } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        } else if (type.lastIndexOf("Array<", 0) === 0) { // string.startsWith pre es6
            let subType: string = type.replace("Array<", ""); // Array<Type> => Type>
            subType = subType.substring(0, subType.length - 1); // Type> => Type
            let transformedData: any[] = [];
            for (let index = 0; index < data.length; index++) {
                let datum = data[index];
                transformedData.push(ObjectSerializer.serialize(datum, subType));
            }
            return transformedData;
        } else if (type === "Date") {
            return data.toISOString();
        } else {
            if (enumsMap[type]) {
                return data;
            }
            if (!typeMap[type]) { // in case we dont know the type
                return data;
            }

            // Get the actual type of this object
            type = this.findCorrectType(data, type);

            // get the map for the correct type.
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            let instance: {[index: string]: any} = {};
            for (let index = 0; index < attributeTypes.length; index++) {
                let attributeType = attributeTypes[index];
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type);
            }
            return instance;
        }
    }

    public static deserialize(data: any, type: string) {
        // polymorphism may change the actual type.
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        } else if (type.lastIndexOf("Array<", 0) === 0) { // string.startsWith pre es6
            let subType: string = type.replace("Array<", ""); // Array<Type> => Type>
            subType = subType.substring(0, subType.length - 1); // Type> => Type
            let transformedData: any[] = [];
            for (let index = 0; index < data.length; index++) {
                let datum = data[index];
                transformedData.push(ObjectSerializer.deserialize(datum, subType));
            }
            return transformedData;
        } else if (type === "Date") {
            return new Date(data);
        } else {
            if (enumsMap[type]) {// is Enum
                return data;
            }

            if (!typeMap[type]) { // dont know the type
                return data;
            }
            let instance = new typeMap[type]();
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            for (let index = 0; index < attributeTypes.length; index++) {
                let attributeType = attributeTypes[index];
                instance[attributeType.name] = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type);
            }
            return instance;
        }
    }
}

export interface Authentication {
    /**
    * Apply authentication settings to header and query params.
    */
    applyToRequest(requestOptions: localVarRequest.Options): Promise<void> | void;
}

export class HttpBasicAuth implements Authentication {
    public username: string = '';
    public password: string = '';

    applyToRequest(requestOptions: localVarRequest.Options): void {
        requestOptions.auth = {
            username: this.username, password: this.password
        }
    }
}

export class HttpBearerAuth implements Authentication {
    public accessToken: string | (() => string) = '';

    applyToRequest(requestOptions: localVarRequest.Options): void {
        if (requestOptions && requestOptions.headers) {
            const accessToken = typeof this.accessToken === 'function'
                            ? this.accessToken()
                            : this.accessToken;
            requestOptions.headers["Authorization"] = "Bearer " + accessToken;
        }
    }
}

export class ApiKeyAuth implements Authentication {
    public apiKey: string = '';

    constructor(private location: string, private paramName: string) {
    }

    applyToRequest(requestOptions: localVarRequest.Options): void {
        if (this.location == "query") {
            (<any>requestOptions.qs)[this.paramName] = this.apiKey;
        } else if (this.location == "header" && requestOptions && requestOptions.headers) {
            requestOptions.headers[this.paramName] = this.apiKey;
        } else if (this.location == 'cookie' && requestOptions && requestOptions.headers) {
            if (requestOptions.headers['Cookie']) {
                requestOptions.headers['Cookie'] += '; ' + this.paramName + '=' + encodeURIComponent(this.apiKey);
            }
            else {
                requestOptions.headers['Cookie'] = this.paramName + '=' + encodeURIComponent(this.apiKey);
            }
        }
    }
}

export class OAuth implements Authentication {
    public accessToken: string = '';

    applyToRequest(requestOptions: localVarRequest.Options): void {
        if (requestOptions && requestOptions.headers) {
            requestOptions.headers["Authorization"] = "Bearer " + this.accessToken;
        }
    }
}

export class VoidAuth implements Authentication {
    public username: string = '';
    public password: string = '';

    applyToRequest(_: localVarRequest.Options): void {
        // Do nothing
    }
}

export type Interceptor = (requestOptions: localVarRequest.Options) => (Promise<void> | void);
